import { api } from './client.js';

const buildQuery = (params = {}) => {
  const clean = Object.entries(params).reduce((acc, [k, v]) => {
    if (v !== undefined && v !== null && v !== '') acc[k] = v;
    return acc;
  }, {});
  const qs = new URLSearchParams(clean).toString();
  return qs ? `?${qs}` : '';
};

export const getJobListings = async (params = {}) => {
  return api.get(`/company/jobs${buildQuery(params)}`);
};

/** IDs for current list filters — used by select-all across pages. */
export const getJobListingIds = async (params = {}) => {
  return api.get(`/company/jobs/ids${buildQuery(params)}`);
};

/** Minimal id/title/description for invite-link job dropdown (single indexed query). */
export const getJobsForInviteSelect = async (params = {}) => {
  return api.get(`/company/jobs/invite-select${buildQuery(params)}`);
};

export const getExpiredJobListings = async (params = {}) => {
  return api.get(`/company/jobs/expired${buildQuery(params)}`);
};

export const getExpiredJobListingsCount = async () => {
  return api.get('/company/jobs/expired/count');
};

export const restoreJobListing = async (id, payload) => {
  if (!id) return Promise.reject(new Error('Job id is required'));
  return api.post(`/company/jobs/${id}/restore`, payload);
};

export const bulkRestoreJobListings = async (payload) => {
  return api.post('/company/jobs/bulk/restore', payload);
};

export const getJobListingById = async (id) => {
  if (!id) return Promise.reject(new Error('Job id is required'));
  return api.get(`/company/jobs/${id}`);
};

export const getJobListingSavedCandidates = async (id) => {
  if (!id) return Promise.reject(new Error('Job id is required'));
  return api.get(`/company/jobs/${id}/saved-candidates`);
};

export const getJobListingMatchedCandidates = async (id, params = {}) => {
  if (!id) return Promise.reject(new Error('Job id is required'));
  return api.get(`/company/jobs/${id}/matched-candidates${buildQuery(params)}`);
};

export const allocateCandidateToJob = async (jobId, candidateId) => {
  if (!jobId || !candidateId) return Promise.reject(new Error('Job id and candidate id are required'));
  return api.post(`/company/jobs/${jobId}/allocate/${candidateId}`, {});
};

export const createJobListing = async (payload) => {
  return api.post('/company/jobs', payload);
};

export const updateJobListing = async (id, payload) => {
  return api.put(`/company/jobs/${id}`, payload);
};

export const checkJobListingContentDuplicate = async (params = {}) => {
  const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value === undefined || value === null || value === '') return acc;
    if (Array.isArray(value)) {
      acc[key] = JSON.stringify(value);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
  return api.get(`/company/jobs/duplicate-check${buildQuery(cleanParams)}`);
};

export const deleteJobListing = async (id) => {
  return api.delete(`/company/jobs/${id}`);
};

export const bulkDeleteJobListings = async (ids) => {
  return api.post('/company/jobs/bulk/delete', { ids });
};
